import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
import { PropertyAlert } from "./PropertyAlert";
import { PropertySimpleText } from "./PropertySimpleText";
export function PropertyText(props) {
    const { property, variant, severity, showIcon, sx, textMode = "markdown", } = props;
    // property is missing
    if (!property) {
        return _jsx(Fragment, {});
    }
    // nothing to display for LDP case
    if (property.isLanguageDependent && !property.name && !property.description) {
        return _jsx(Fragment, {});
    }
    // nothing to display for non-LDP case
    if (!property.isLanguageDependent && property.value == null) {
        return _jsx(Fragment, {});
    }
    if (variant === "alert") {
        return (_jsx(PropertyAlert, { property: property, severity: severity, showIcon: showIcon, textMode: textMode }));
    }
    return _jsx(PropertySimpleText, { property: property, textMode: textMode, sx: sx });
}
//# sourceMappingURL=PropertyText.js.map